<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" scrollable>
		<v-card max-height="600px">
			<v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
			<v-divider></v-divider>
            <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <v-text-field label="Título" v-model="aviso.titulo" outlined></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-menu ref="abrirDtInicio" v-model="abrirDtInicioPicker" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
						    <template v-slot:activator="{ on }">
							    <v-text-field label="Data Inicio" v-model="dataInicioFormatada" v-on="on" outlined></v-text-field>
						    </template>
						    <v-date-picker locale="pt-br" v-model="dataInicio" no-title @input="abrirDtInicioPicker = false"></v-date-picker>
					    </v-menu>
                    </v-col>
                    <v-col cols="6">
                        <v-menu ref="abrirDtFim" v-model="abrirDtFimPicker" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
						    <template v-slot:activator="{ on }">
							    <v-text-field label="Data Fim" v-model="dataFimFormatada" v-on="on" outlined></v-text-field>
						    </template>
						    <v-date-picker locale="pt-br" v-model="dataFim" no-title @input="abrirDtFimPicker = false"></v-date-picker>
					    </v-menu>
                    </v-col>
                    <v-col cols="12">
                        <VueEditor v-model="aviso.conteudo" placeholder="Informe o Conteúdo do Aviso..." />
                    </v-col>
                </v-row>
            </v-container>
            </v-card-text>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="salvar()">Salvar</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>    
</template>

<script>
import Br from '@/config/barramento.js'
import metodos from '@/mixins/metodos'
import {VueEditor} from "vue2-editor"
// import { mapState } from 'vuex'
import { baseApiUrl, showError, showSuccess } from "@/config/global"
import axios from 'axios'


export default {
    name: 'Aviso',
    mixins: [metodos],
    components:{
        VueEditor
    },
    data(){
        return{
            cor: 'primary',
            mostrar: false,
            aviso: {},
            abrirDtInicioPicker: false,
            abrirDtFimPicker: false,
            dataInicio: '',
            dataInicioFormatada: '',
            dataFim: '',
            dataFimFormatada: '',
        }
    },

    methods:{
        salvar(){
            const url = `${baseApiUrl}/Cadastros/avisos/update.php`
					
					if(this.aviso.titulo && this.aviso.conteudo && this.aviso.data_inicio && this.aviso.data_fim){

						axios.post(url, this.aviso)
						.then(res => { 
							if(res.data.codigo == '01'){
                                showSuccess(res.data.mensagem)
                                Br.setAvisoAtualizado(this.aviso)
                                this.aviso = {}
                                this.mostrar = false
							}else{
								showError(res.data.mensagem)
							}
						})
					}else{
						showError("Todos os campos devem ser preenchidos!")
					}
        },

        fechar(){
            this.mostrar = false
        }
    },

    created(){
    
        Br.onEditarAviso(aviso => {
            this.aviso = aviso
            this.dataInicioFormatada = this.formataDateBr(this.aviso.inicioObj.toISOString().substr(0, 10))
            this.dataFimFormatada = this.formataDateBr(this.aviso.fimObj.toISOString().substr(0, 10))
            this.mostrar = true
        })
    },

    watch:{
        dataInicio(val){
				this.dataInicioFormatada = this.formataDateBr(this.dataInicio)
				this.aviso.inicioObj = this.converterData(this.dataInicio)
        },

        dataFim(val){
				this.dataFimFormatada = this.formataDateBr(this.dataFim)
				this.aviso.fimObj = this.converterData(this.dataFim)
        },
    }
}
</script>

<style scoped>

</style>